<template>
  <div class="top-header-wrapper">
    <!-- <div type="button" @click="showRiskModal" style="text-align: center; margin-right: 12px; cursor: pointer;">
      <span>疫情<br/>风险区</span>
    </div> -->
    <div class="top-header">
      <div class="header-left-content" >
      </div>
      <div class="header-right-content">
        <div class="header-user-info">
          <el-popover placement="bottom" popper-class="r-popover">
            <div>
              <div class="popover-btn" type="button" @click="toManager">
                <span>经营信息</span>
              </div>
              <div class="popover-btn" type="button" @click="toPersonal">
                <span>个人中心</span>
              </div>
              <div class="popover-btn" type="button" @click="_logout">
                <span>退出登录</span>
              </div>
            </div>
            <template #reference>
              <span class="header-user-dropdown">
                <img class="header-user-img" :src="require('../../assets/img/top_administrator.png')" :onerror="iconHead" alt="..." />
                <!-- <span class="header-user">{{ userName }}</span> -->
                <span class="header-user">{{LoginonUser.account}}</span>
                <el-icon class="el-icon--right">
                  <arrow-down width="18px" height="18px" />
                </el-icon>
              </span>
            </template>
          </el-popover>
        </div>
      </div>
    </div>


    <RModal
      title="疫情风险地区"
      top="5vh"
      :show="showModal"
      :closeOnClick="false"
      width="1300px"
      @change="showModal = false"
      @close="showModal = false"
    >
      <template #content>
        <ThirdRisk iframe-class="risk-iframe" />
      </template>
    </RModal>
  </div>
</template>
<script>
import RModal from "@/components/common/RModal"
import ThirdRisk from "@/views/third/risk"
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'TopHeader',
  components: { RModal, ThirdRisk },
  computed: {
    ...mapState({
      logoutState: (state) => state.common.logout,
      loginState: (state) => state.common.login,
      LoginonUser: (state) => state.common.user,
    }),
    ...mapGetters(['infoCenterShow']),
  },

  data() {
    return {
      showModal: false,

      iconHead: 'this.src="' + require('../../assets/img/b5.png') + '"',
      searchPerm: false,
      userName: '',
    }
  },
  created() {
    this.userName = this.LoginonUser.realName || this.LoginonUser.phoneNum
  },
  watch: {
    logoutState: {
      handler(to, from) {
        if (to.status !== '') {
          this.$router.push('/account/login')
        }
      },
      deep: true,
    },
    loginState: {
      handler(to, from) {
        if (to.status === 'failure') {
          this.alertToggle({
            alertType: 'danger',
            alertContent: to.msg,
          })
          this.$router.push('/account/login')
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(['alertToggle', 'logout', 'fetchData']),
    _logout() {
      this.logout()
    },
    // 展示疫情风险地区弹框
    showRiskModal() {
      this.showModal = true
    },
    // 跳转到个人中心
    toPersonal() {
      this.$router.push('/personal?name=accountAndSafe')
    },
    toManager() {
      this.$router.push('/personal?name=manager')
    },
    //修改个人资料
    onUpdate(formData) {
      let url = 'USER.UPDATE'
      let userInfo = {
        id: this.LoginonUser.id,
        ...formData,
      }
      //菜单打开方式
      userInfo.openNewTab = userInfo.openNewTab ? 'T' : 'F'
      //默认页
      /* userInfo.indexPage = userInfo.indexPage ? 'gerengongzuotai' : 'zhengtigailan'*/
      userInfo.indexPage = userInfo.indexPage
      let params = {
        user: JSON.stringify(userInfo),
      }
      this.fetchData({ url, method: 'post', params, isLoading: true })
        .then((res) => {
          $('#person-info-form').modal('hide')
          this.$store.commit('THEME_COLOR', this.$enum.themeType[formData.themeId])
          this.$store.commit('OPEN_NEW_TAB', userInfo.openNewTab)
          this.alertToggle({
            alertType: 'success',
            alertContent: '个人资料修改成功',
          })
        })
        .catch((err) => {
          this.alertToggle({
            alertType: 'danger',
            alertContent: err,
          })
        })
    }
  },
}
</script>
<style lang="less" scoped>
.top-header-wrapper{
  display: flex;
  .top-header {
    .header-left-content {
      display: flex;
      align-items: center;
      cursor: pointer;
      .header-logo-img {
        margin-left: 10px;
        max-height: 42px;
        cursor: pointer;
        z-index: 9;
      }
      .header-extra-img {
        margin-top: 11px;
        margin-left: 35px;
        width: 20px;
        height: 15px;
      }
    }
    .header-right-content {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .header-clock {
        display: flex;
        .date-time {
          color: rgba(37, 188, 240, 1);
          font-size: 30px;
          margin-right: 30px;
        }
        .cur-date {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          font-size: 12px;
          color: rgba(37, 188, 240, 1);
        }
      }
      .header-user-info {
        .header-user-dropdown {
          display: flex;
          align-items: center;
          cursor: pointer;
        }
        .header-user-img {
          width: 36px;
          height: 36px;
        }
        .header-user {
          font-size: 16px;
          margin: 0 15px;
        }
      }
    }
  }
}
.popover-btn {
  padding: 8px 0px;
  text-align: center;
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
</style>

<style lang="less">
.risk-iframe {
  width: 1180px;
  height: 700px;
}
</style>